import OnlineAppComponent from "../lib/online_app_component";

export const OnlineAppFooterConfig = {
    baseHtmlClass: 'online_app__footer',
    selector: '.online_app__footer'
}

export class OnlineAppFooter extends OnlineAppComponent {

    constructor(id_or_element, onlineApp) {
        super(id_or_element, onlineApp, OnlineAppFooterConfig);
        this.closer = new FooterCloser(this);
        this.render();
    }

    getHeight() {
        try {
            return this.element.offsetHeight;
        } catch {
            return 0;
        }
    }

    destroy() {
        if (this.onlineApp?.footer) this.onlineApp.footer = null;
        this.element.remove();
    }

    render() {
        this.swapHtmlClassStates(this.readStateMachineValue('footerOpen'), 'open', 'closed');
    }

}

export function getFooter(element, onlineApp) {
    if (!element) return null;
    return new OnlineAppFooter(element, onlineApp);
}


const FooterCloserConfig = {
    baseHtmlClass: 'online_app__footer__closer'
}

export class FooterCloser extends OnlineAppComponent {

    constructor(onlineAppFooter) {
        super(null, onlineAppFooter.onlineApp, FooterCloserConfig);
        this.element = FooterCloser.createElement(FooterCloserConfig.baseHtmlClass);
        this.onlineAppFooter = onlineAppFooter;
        this.onlineAppFooter.element.appendChild(this.element);

        this.element.addEventListener('click', (event) => {
            this.dispatchAction('footerCloserSelected', this);
        });

    }

    renderContent() {
        this.element.innerHTML = this.content;
    }

    render() {
        this.content = '✗';
        this.renderContent();
    }

    destroyFooter() {
        if (this.onlineAppFooter) this.onlineAppFooter.destroy();
    }
}
